import clsx from 'clsx';
import type { Recurso } from '../dados/recursos';
import { ARTES } from './ilustracoes-bento';

type CartaoBentoProps = {
  recurso: Recurso;
};

/**
 * Cartão do bento de recursos.
 *
 * ## Nenhuma luz seguindo o cursor aqui — e é decisão, não esquecimento
 * O cartão teve dois efeitos de cursor, os dois removidos a pedido do dono:
 * o arco na borda (a "lanterna") e depois o holofote interno. O motivo é o
 * mesmo nas duas vezes: a CENA dentro do cartão já é o assunto — ela tem o
 * neon do produto e o pulso correndo pela borda —, e luz extra seguindo o
 * mouse competia com ela em vez de somar. O que sobrou no hover é o
 * `.cartao-reativo` (levanta 4px) mais borda e sombra: reação suficiente
 * para o clique parecer vivo, discreta o bastante para não roubar a cena.
 *
 * Com isso saiu também o último `mousemove` da seção — o hook `useHolofote`
 * ficou sem nenhum consumidor e foi apagado junto.
 */
export function CartaoBento({ recurso }: CartaoBentoProps): JSX.Element {
  const Arte = ARTES[recurso.arte];

  return (
    <div
      className={clsx(
        // O deslocamento e a compressão do toque vêm de `.cartao-reativo`; a
        // borda e a sombra do hover continuam aqui, porque são tokens do tema.
        'cartao-reativo cartao-vidro hover:border-auth-borda/20 hover:shadow-auth-profundidade group relative flex flex-col gap-4 overflow-hidden p-6',
        /* Quatro quadros IGUAIS, dois por linha — ver o racional em
           `recursos-bento.tsx` e `ilustracoes-bento.tsx`. */
        'min-h-[22rem]',
      )}
    >
      {/* Sangra até as bordas do cartão (margens negativas): ilustração
          premium ocupa o quadro, não flutua pequena no escuro. */}
      <div aria-hidden className="-mx-6 -mt-6 h-52 shrink-0 sm:h-56">
        <Arte />
      </div>
      <div className="relative z-10 mt-auto flex flex-col gap-2">
        <h3 className="text-auth-texto text-lg font-medium tracking-tight">
          {recurso.titulo}
        </h3>
        <p className="text-auth-texto-secundario max-w-md text-sm leading-relaxed">
          {recurso.texto}
        </p>
      </div>
    </div>
  );
}
